import { getDefaultMargin, getDefaultMarginOverlay, getDefaultWidthOverlay } from '../utils'

export const TabsDesignSettings = {
  // dimension
  'tabs-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },

  // orientation
  'tabs-design-orientation': {
    phone: 'horizontal',
    'phone-landscape': 'horizontal',
    tablet: 'horizontal',
    'tablet-landscape': 'horizontal',
    desktop: 'horizontal',
    tv: 'horizontal',
  },

  // alignment
  'tabs-design-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'tabs-design-content-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },

  // spacing
  'tabs-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'tabs-design-padding': {
    phone: getDefaultMargin([4]),
    'phone-landscape': getDefaultMargin([4]),
    tablet: getDefaultMargin([4]),
    'tablet-landscape': getDefaultMargin([4]),
    desktop: getDefaultMargin([4]),
    tv: getDefaultMargin([4]),
  },
  'tabs-design-item-padding': {
    phone: getDefaultMargin([8, 12]),
    'phone-landscape': getDefaultMargin([8, 12]),
    tablet: getDefaultMargin([8, 12]),
    'tablet-landscape': getDefaultMargin([8, 12]),
    desktop: getDefaultMargin([8, 12]),
    tv: getDefaultMargin([8, 12]),
  },
  'tabs-design-content-padding': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },
}
